(function() {
  // Only run if there's a search input
  const searchInput = document.querySelector('[data-placeholders]');
  if (!searchInput) return;

  const placeholders = JSON.parse(searchInput.dataset.placeholders);
  let currentIndex = 0;
  let currentText = '';
  let currentCharIndex = 0;
  let isDeleting = false;
  let typingSpeed = 100;
  let deletingSpeed = 50;
  let pauseTime = 3000;
  const staticPrefix = "Søg efter ";
  let animationFrame;
  let lastTimestamp = 0;
  
  // Stop animation when input is focused
  searchInput.addEventListener('focus', () => {
    if (animationFrame) {
      cancelAnimationFrame(animationFrame);
      animationFrame = null;
    }
  });

  // Resume animation when input is blurred
  searchInput.addEventListener('blur', () => {
    if (!animationFrame) {
      lastTimestamp = performance.now();
      animate();
    }
  });

  function animate(timestamp) {
    if (!lastTimestamp) lastTimestamp = timestamp;
    const elapsed = timestamp - lastTimestamp;

    const currentPlaceholder = placeholders[currentIndex];
    const lastWord = currentPlaceholder.replace(staticPrefix, '');
    
    if (isDeleting) {
      if (elapsed >= deletingSpeed) {
        currentText = staticPrefix + lastWord.substring(0, currentCharIndex - 1);
        currentCharIndex--;
        searchInput.placeholder = currentText;
        lastTimestamp = timestamp;
        
        if (currentCharIndex === 0) {
          isDeleting = false;
          currentIndex = (currentIndex + 1) % placeholders.length;
          setTimeout(() => {
            lastTimestamp = performance.now();
            animationFrame = requestAnimationFrame(animate);
          }, 500);
          return;
        }
      }
    } else {
      if (elapsed >= typingSpeed) {
        currentText = staticPrefix + lastWord.substring(0, currentCharIndex + 1);
        currentCharIndex++;
        searchInput.placeholder = currentText;
        lastTimestamp = timestamp;
        
        if (currentCharIndex === lastWord.length) {
          isDeleting = true;
          setTimeout(() => {
            lastTimestamp = performance.now();
            animationFrame = requestAnimationFrame(animate);
          }, pauseTime);
          return;
        }
      }
    }
    
    animationFrame = requestAnimationFrame(animate);
  }

  // Start animation
  animationFrame = requestAnimationFrame(animate);
})();